import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000"; // Adjust base URL as needed

const GuideListingService = {
  getAvailableGuests: async (tourListingId, bookingDate) => {
    try {
      // The parameters are correctly embedded in the URL path.
      // Removed the unnecessary 'params' object from the axios configuration.
      const response = await axios.get(
        `${API_BASE_URL}/guide-listing/tour-listings/${tourListingId}/guest-count/${bookingDate}`
        // Removed the second argument: { params: { tourListingId, bookingDate } }
      );

      // Assuming the successful response structure is similar to the Dart code,
      // where the desired data is directly available in response.data.
      console.log("response.body", response.data);
      return response.data["data"];
    } catch (error) {
      console.error("Error fetching available guests:", error);
      throw error;
    }
  },
  // Other guide listing related services can be added here
};

export default GuideListingService;
